export default __webpack_public_path__ + "static/media/page-not-found.bf3a12a2.png";